<!--
 * @Description: 
 * @Date: 2020-09-24 20:03:35
-->
<template>
  <van-tabs class="living-tab" v-model="activeIndex" :swipe-threshold="1" :ellipsis="false">
    <van-tab v-for="(item, index) in livingStore.zdyMenuList" :key="index" :title="item.name"></van-tab>
  </van-tabs>
</template>

<script>
export default {
  name: 'LivingTabs',
  inject: ['livingStore'],
  props: {
    tabs: {
      type: Array,
      default() {
        return [];
      }
    },
    value: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      activeIndex: 0
    };
  },
  watch: {
    activeIndex: {
      handler(v){
        this.$store.commit('living/SET_COMMON', {
          field: 'currentZdyMenu',
          value: this.livingStore.zdyMenuList[v]
        });
      },
      immediate: true
    }
  }
};
</script>

<style lang="scss">
.living-tab {
  border-top: 0.09rem solid #ededed;
  border-bottom: 0.09rem solid #ededed;
  .van-tabs__wrap {
    height: 0.95rem;
  }
  .van-tabs__nav {
    padding-bottom: 0;
  }
  .van-tabs__line {
    display: none;
  }
  .van-tab__text {
    font-size: 0.37rem;
    color: #666666;
    font-weight: 500;
  }
  .van-tab--active {
    // font-size: ;
    .van-tab__text {
      font-size: 0.48rem;
      color: #000000;
      font-weight: bold;
    }
  }
}
</style>
